<template>
  <section class="case-details-verification-card mb-4" :class="`is-${statusTone}`">
    <div class="case-details-verification-accent"></div>
    <div class="case-details-verification-header">
      <div class="text-uppercase fw-bold text-x secondary-color mb-3">Verify Case Facts</div>

      <div class="case-details-verification-main-row d-flex align-items-start justify-content-between gap-3 w-100">
        <div class="d-flex align-items-start gap-3 min-w-0">
          <span class="case-details-verification-icon d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-shield-check"></i>
          </span>
          <div class="min-w-0">
            <div class="case-details-verification-title">{{ title }}</div>
            <div class="case-details-verification-copy">{{ description }}</div>
            <div class="d-flex flex-wrap gap-2 mt-2">
              <span v-for="row in rows" :key="`verification-field-${row.field}`" class="case-details-verification-field-pill">
                {{ row.field }}
              </span>
            </div>
          </div>
        </div>
        <div class="case-details-verification-status text-end flex-shrink-0">
          <span class="case-details-verification-status-badge" :class="`is-${statusTone}`">{{ status }}</span>
          <div class="case-details-verification-last-run">Last run: {{ lastRun }}</div>
        </div>
      </div>
    </div>

    <div class="case-details-verification-actions d-flex align-items-center justify-content-end gap-2">
      <button v-if="hasRun" type="button" class="btn btn-light border px-3" @click="resultsOpen = !resultsOpen">
        {{ resultsOpen ? 'Close' : 'Open' }}
      </button>
      <button type="button" class="btn btn-primary-dark px-3" :disabled="running || !runnable" @click="$emit('rerun')">
        {{ running ? 'Running verification...' : hasRun ? 'Re-run verification' : 'Run verification' }}
      </button>
    </div>

    <div v-if="!runnable && unavailableMessage" class="case-details-verification-unavailable">
      {{ unavailableMessage }}
    </div>

    <div v-if="hasRun && resultsOpen" class="case-details-verification-details">
      <div class="case-details-verification-details-label">Result details</div>
      <div v-if="message" class="case-details-verification-copy mb-3">{{ message }}</div>
      <div class="table-responsive">
        <table class="case-details-verification-table">
          <thead>
            <tr>
              <th>Field</th>
              <th>Submitted value</th>
              <th>Provider value</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="`verification-result-${row.field}`">
              <td class="fw-semibold">{{ row.field }}</td>
              <td>{{ row.submitted_value }}</td>
              <td>{{ row.provider_value }}</td>
              <td><span class="case-details-verification-result-status" :class="`is-${row.tone}`">{{ row.status }}</span></td>
            </tr>
            <tr v-if="!rows.length">
              <td colspan="4" class="text-center secondary-color py-3">No field-level results were returned by the provider.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CaseVerificationCard',
  emits: ['rerun'],
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    lastRun: {
      type: String,
      default: '-',
    },
    running: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Case verification',
    },
    description: {
      type: String,
      default: 'Checks submitted case facts against the available provider information.',
    },
    status: {
      type: String,
      default: 'Pass',
    },
    statusTone: {
      type: String,
      default: 'neutral',
    },
    hasRun: {
      type: Boolean,
      default: false,
    },
    runnable: {
      type: Boolean,
      default: true,
    },
    unavailableMessage: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    resultsOpen: true,
  }),
};
</script>
